import ButtonBase from '@mui/material/ButtonBase';
import styled from "styled-components";
import Box from "component/layoutComponents/Box";
import Typography from '@mui/material/Typography';
import DefaultUptimeTheme from "component/theme/defaultTheme";
import { Slider } from 'component/commonComponents/Slider';

type DefaultTheme = typeof DefaultUptimeTheme;

export const OutlinedContainer = styled(Box)<{
  theme: DefaultTheme;
  padding: string;
  checked: boolean;
}>(({ theme, checked, padding }) => ({
  width: "100%",
  padding: padding || `${theme.uptimeSpace[8]}px`,
  borderRadius: "8px !important",
  background: checked
    ? `${theme.uptimeColors.mainTheme.background}!important`
    : "transparent",
  border: checked
    ? "none !important"
    : `1px solid ${theme.uptimeColors.grayScales.grayish} !important`,
}));

export const StyledButton = styled(ButtonBase)<{
  theme: DefaultTheme;
  checked: boolean;
  padding?: string;
}>(({ theme, checked, padding }) => ({
  height: "100% !important",
  width: "100% !important",
  display: "inherit !important",
  padding: `${
    padding || `${theme.uptimeSpace[4]}px ${theme.uptimeSpace[8]}px`
  } !important`,
  borderRadius: "8px !important",
  background: checked
    ? `${theme.uptimeColors.mainTheme.background} !important`
    : theme.uptimeColors.grayScales.white,
  border: checked ? "none !important" : "1px solid #0000001F !important",
}));

export const TextBlack = styled(Typography)<{ theme: DefaultTheme }>(
  ({ theme }) => ({
    color: theme.uptimeColors.textColors.primary,
  })
);

export const TextGray = styled(Typography)<{ theme: DefaultTheme }>(
  ({ theme }) => ({
    color: theme.uptimeColors.textColors.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    whiteSpace:'nowrap'
  })
);

export const StyledTitle = styled(TextBlack)(
  ({ theme }: { theme: DefaultTheme }) => ({
    fontSize: `${theme.uptimeFontSizes.desktop.fz11}px`,
  })
);

export const StyledSubtitle = styled(TextBlack)(
  ({ theme }: { theme: DefaultTheme }) => ({
    fontSize: `${theme.uptimeFontSizes.desktop.fz7}px`,
  })
);

export const StyledImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const StyledSlider = styled(Slider)`
  ${({ theme }) => `
    @media(min-width: 0px){
      .slick-prev{
        left: 5px;
      }
      .slick-next{
        right: 5px;
      }
    }
    @media(min-width: 480px){
      margin-left: -${theme.uptimeSpace[6]}px;
      width: calc(100% + 12px);
      .slick-prev{
        left: -25px;
      }
      .slick-next{
        right: -25px;
      }
    }
  `}
`;

export const ReligionButton = styled(StyledButton)(
  ({ theme, checked }: { theme: DefaultTheme; checked: boolean }) => ({
    padding: "16px !important",
    background: "transparent !important",
    border: checked
      ? `1px solid ${theme.uptimeColors.mainTheme.primary} !important`
      : `1px solid ${theme.uptimeColors.grayScales.grayish} !important`,
  })
);
